/**
 * Checkbox with value field used on Step05 Quote Variation
 * inside the Cover options menu
 *
 * @param {function} handleItemChange [This should have the function so set the value on the parent]
 * @param {boolean} value             [Have the value of the value box. Default: 0]
 * @param {string} title              [Text printed next to the checkbox]
 * @param {string} id                 [Name of the field]
 * @param {string} placeholder        [Placeholder text for the value box]
 * @param {ReactDOM} children         [Description of the ToolTip, would be the child]
 */

/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

import Checkbox from '../../../../common/Checkbox/Checkbox'
import ToolTip from '../../../../common/ToolTip/ToolTip'
import { symbol } from '../../../../common/CurrencyFormat'
import DatePicker from '../../../../common/DatePicker/DatePicker'

export default class OptionsItem extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            checked: (this.props.value === null || this.props.value === 0) ? false : true,
            inputValue: (this.props.value === null || this.props.value === 0) ? '' : this.props.value,
            changeState: false,
            retroactiveDate: this.props.retroactiveDate ? this.props.retroactiveDate : '',
        }
    }

    componentWillUpdate(nextProps: any, nextState: any) {
        if (nextProps.value !== this.props.value) {
            this.setState({
                checked: (nextProps.value === null || nextProps.value === 0) ? false : true,
                inputValue: (nextProps.value === null || nextProps.value === 0) ? '' : nextProps.value,
                retroactiveDate: (nextProps.retroactiveDate) ? nextProps.retroactiveDate : '',
            })
        }
    }

    handleCheckbox = (value: any, field: string) => {
        const { datePickerShow = false, retroactiveDate = '', isMTA = false } = this.props
        if (!value) {
            this.props.handleItemChange(field, null)
            this.setState({ inputValue: 0 })
        } else {
            this.props.handleItemChange(field, 0)
            this.setState({ inputValue: '' })
        }

        if (datePickerShow) {
            if (!isMTA) {
                this.props.handleItemChange('retroactiveDate', '')
                this.setState({ retroactiveDate: !value ? '' : retroactiveDate })
            } else if (isMTA && !retroactiveDate) {
                this.props.handleItemChange('retroactiveDate', '')
                this.setState({ retroactiveDate: !value ? '' : retroactiveDate })
            }
        }

        this.setState({ checked: !this.state.checked, changeState: false })
    }

    handleInput = (event) => {
        this.setState({ inputValue: parseInt(event.target.value, 10) })
        this.props.handleItemChange(event.target.name, parseInt(event.target.value, 10))
    }

    render() {
        const { datePickerShow = false, customCls = '', isMTA = false, retroactiveDate: retroDate = '' } = this.props
        const { retroactiveDate, checked } = this.state

        return (
            <div className={`options__item options__item--${this.props.id} ${customCls}`}>
                <Checkbox
                    name={this.props.id}
                    selected={this.state.checked}
                    onChange={this.handleCheckbox}
                    changeState={this.state.changeState}
                >
                    <span>{this.props.title}</span>
                    {!(this.props.hideTooltip) ?
                        (<ToolTip>{this.props.children}</ToolTip>) :
                        null
                    }
                </Checkbox>

                <div className={`${datePickerShow ? 'datepickerGroup' : ''}`} >
                    <div
                        className="value pound"
                        onClick={() => {
                            this.setState({ changeState: true })
                        }
                        }
                        data-text={symbol()}
                    >
                        <input
                            type="number"
                            name={`${this.props.id}`}
                            onChange={this.handleInput}
                            placeholder={this.props.placeholder || '0'}
                            readOnly={!this.state.checked}
                            value={this.state.inputValue}
                        />
                    </div>
                    {datePickerShow && (
                        <DatePicker
                            key={`retro_date_${checked}`}
                            customClass={`retro_date ${(!checked || (isMTA && retroDate)) ? 'retroDisable' : ''}`}
                            placeholder={
                                retroactiveDate && typeof retroactiveDate === 'string'
                                    ? new Date(retroactiveDate).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: 'long',
                                        year: 'numeric',
                                    })
                                    : 'Retroactive date'
                            }
                            onChange={(retroactive) => {
                                this.setState({ retroactiveDate: retroactive })
                                this.props.handleItemChange('retroactiveDate', retroactive)
                            }
                            }
                            retroDate={true}
                            dateSelected={retroactiveDate}
                            placeholderIsDate={retroactiveDate ? true : false}
                            onFocus={() => null}
                            displayOptions={{
                                layout: 'portrait',
                                showOverlay: true,
                                shouldHeaderAnimate: true,
                                showHeader: true,
                                showTodayHelper: true,
                            }}
                        />
                    )}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05/components/OptionsItem.tsx